export default __webpack_public_path__ + "static/media/photo--sm--76.ca77a96f.jpg";